import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Skeleton from '../components/ui/Skeleton';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch('/api/posts');
        let data = await response.json();
        data = data.filter(post => post.visibility === "Active");
        data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(data);
      } catch (error) {
        // Error handled silently
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const renderSkeleton = () => (
    <div className="relative shadow-md rounded-lg overflow-hidden p-4">
      <Skeleton className="w-full h-48 mb-2 rounded-md" />
      <Skeleton className="h-5 w-3/4 mb-2" />
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-gray-50 py-12 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-4">
            <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
              Our Blog
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest news, tips, and insights about the automotive world.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {Array(8).fill(null).map((_, index) => (
              <div key={index}>{renderSkeleton()}</div>
            ))}
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center py-20">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">No Posts Found</h2>
            <p className="text-gray-600">Please check back later for new content.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {posts.map((post) => (
              <div
                key={post._id}
                className="relative bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              >
                <div className="relative">
                  <div className="overflow-hidden">
                    <Link to={`/blog/${post._id}`}>
                      <img
                        src={post.image || post.thumbnail || 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&q=80'}
                        alt={post.title}
                        className="w-full h-48 object-cover transition-transform duration-500 ease-in-out hover:scale-110"
                      />
                    </Link>
                  </div>
                  <div className="p-5">
                    <Link to={`/blog/${post._id}`}>
                      <h2 className="font-display text-heading-sm text-gray-900 mb-2 hover:text-[#DC2626] transition-colors line-clamp-2">
                        {post.title}
                      </h2>
                    </Link>
                    <p className="text-sm text-gray-500 mt-3">
                      <span className="font-medium">Published:</span> {new Date(post.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Blog;
